import React from 'react';
import Home from './Home';
import MarketplaceHome from './MarketplaceHome';
import Layout from '../../components/Layout';
import { getCategory } from '../../actions/category/getCategory';
import featuredProsQuery from './getFeaturedPros.graphql';
import recentReviewsQuery from './getRecentReviews.graphql';
import activeCategoriesQuery from './getActiveCategories.graphql';
import publicStatsQuery from './getPublicStats.graphql';
import HomeV2 from './v2/HomeV2';
import loadHomeV2Data from './v2/loadHomeV2Data';
async function action({ client, store, geo, largeProjectsEnabled, newHomepageEnabled }) {
  const title = store?.getState()?.siteSettings?.data?.siteTitle
  const description = store?.getState()?.siteSettings?.data?.metaDescription;
  const storeCategories = store?.getState()?.categories?.data;

  !storeCategories && store.dispatch(getCategory());

  // NEW HOMEPAGE (home-v2): dev-only. `newHomepageEnabled` is already the final decision
  // (SiteSettings flag AND not a production host, see helpers/newHomepageHostGuard). When it
  // is false, everything below runs exactly as before. Same title/description either way.
  if (newHomepageEnabled === true) {
    const v2 = await loadHomeV2Data(client);
    return {
      title,
      description,
      component: (
        <Layout isHomeV2>
          <HomeV2 tabs={v2.tabs} chips={v2.chips} projects={v2.projects} largeProjectsEnabled={largeProjectsEnabled} />
        </Layout>
      ),
    };
  }

  let pros = [];
  let reviews = [];
  let categories = [];
  let stats = {};
  // Location-aware featured pros: only show workers near the visitor (geo resolved server-side by IP,
  // overridable by the bh_loc cookie). served=false → the home shows a waitlist CTA for that area.
  let served = true;
  let area = (geo && geo.label) || null;
  let nearbyCount = null;
  // Worker photos are NO LONGER gated by region (Paul): the "Meet the pros" rail shows pros NATIONWIDE,
  // like the hero, so photos display everywhere instead of only within 100 mi of NJ/NY/PA. (Reverted the
  // location-aware 100mi filter for the rail; hero/picker/design left unchanged.) `area` keeps the
  // visitor's own detected label — we don't overwrite it with a random nationwide pro's city.
  // No display cap (Paul): show ALL activated pros with a photo, not a subset — 200 is headroom
  // over the current pool so every worker appears (random order each load).
  const proVars = { nationwide: true, limit: 200 };
  try {
    const { data } = await client.query({ query: featuredProsQuery, variables: proVars, fetchPolicy: 'network-only' });
    const fp = data && data.getFeaturedPros;
    pros = (fp && fp.results) || [];
    if (fp && typeof fp.served === 'boolean') served = fp.served;
    if (fp && typeof fp.count === 'number') nearbyCount = fp.count;
  } catch (e) { pros = []; }
  // Hero showcase = NATIONWIDE pros (all states cycle in the top photo), independent of the visitor's region.
  let heroPool = [];
  try {
    const { data } = await client.query({ query: featuredProsQuery, variables: { nationwide: true, limit: 200 }, fetchPolicy: 'network-only' });
    heroPool = (data && data.getFeaturedPros && data.getFeaturedPros.results) || [];
  } catch (e) { heroPool = []; }
  try {
    const { data } = await client.query({ query: recentReviewsQuery, variables: { limit: 6 }, fetchPolicy: 'network-only' });
    reviews = (data && data.getRecentReviews && data.getRecentReviews.results) || [];
  } catch (e) { reviews = []; }
  try {
    const { data } = await client.query({ query: activeCategoriesQuery, fetchPolicy: 'network-only' });
    categories = (data && data.getActiveCategories && data.getActiveCategories.results) || [];
  } catch (e) { categories = []; }
  try {
    const { data } = await client.query({ query: publicStatsQuery, fetchPolicy: 'network-only' });
    stats = (data && data.getPublicStats) || {};
  } catch (e) { stats = {}; }

  // LARGE PROJECTS FLAG: read from the router context (threaded from the
  // server-only DB read in server.js / SSR-seeded runtime on the client) and
  // thread to the home so the LP band + "Join as a company" CTAs render only
  // when ON. Plain boolean — no DB helper import. Fail-closed at the source.

  return {
    title,
    description,
    component: (
      <Layout>
        <MarketplaceHome categories={categories} pros={pros} heroPool={heroPool} reviews={reviews} stats={stats} served={served} area={area} nearbyCount={nearbyCount} largeProjectsEnabled={largeProjectsEnabled} />
      </Layout>
    ),
  };
}

export default action;
